import { FaFacebookF, FaLinkedinIn, FaReddit, FaTelegram, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { SiGoogle, SiInstagram, SiYoutube } from 'react-icons/si';
import { TbWorld } from 'react-icons/tb';

import { useTheme } from 'hooks/useTheme';

interface IconProps {
  color?: string;
  size?: number;
  className?: string;
  useThemeColor?: boolean;
  themeColorKey?: keyof Pick<
    import('hooks/useTheme').ThemeColors,
    'primary' | 'success' | 'warning' | 'info' | 'error'
  >;
}

// Função utilitária que recebe o tema como parâmetro
export const getSocialNetworkIconWithTheme = (
  networkType: string,
  theme: any,
  iconProps: IconProps = {}
): JSX.Element | null => {
  const {
    color,
    size = 16,
    className,
    useThemeColor = false,
    themeColorKey = 'primary',
  } = iconProps;

  let finalColor = color;
  if (useThemeColor && theme) {
    finalColor = theme[themeColorKey];
  } else if (!color) {
    finalColor = theme.primary;
  }

  const iconStyle = {
    color: finalColor,
    fontSize: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  switch (networkType) {
    case 'FACEBOOK':
      return <FaFacebookF style={iconStyle} className={className} />;
    case 'INSTAGRAM':
      return <SiInstagram style={iconStyle} className={className} />;
    case 'LINKEDIN':
      return <FaLinkedinIn style={iconStyle} className={className} />;
    case 'YOUTUBE':
      return <SiYoutube style={iconStyle} className={className} />;
    case 'X':
      return <FaXTwitter style={iconStyle} className={className} />;
    case 'REDDIT':
      return <FaReddit style={iconStyle} className={className} />;
    case 'GOOGLE':
      return <SiGoogle style={iconStyle} className={className} />;
    case 'TELEGRAM':
      return <FaTelegram style={iconStyle} className={className} />;
    case 'WHATSAPP':
      return <FaWhatsapp style={iconStyle} className={className} />;
    case 'WEBSITE':
      return <TbWorld style={iconStyle} className={className} />;
    default:
      return null;
  }
};

// Componente React que pode usar hooks
export const SocialNetworkIcon: React.FC<{
  networkType: string;
  iconProps?: IconProps;
}> = ({ networkType, iconProps = {} }) => {
  const { theme } = useTheme();
  return getSocialNetworkIconWithTheme(networkType, theme, iconProps);
};

// Função de compatibilidade que usa o componente internamente
export const getSocialNetworkIcon = (
  networkType: string,
  iconProps: IconProps = {}
): JSX.Element | null => {
  return <SocialNetworkIcon networkType={networkType} iconProps={iconProps} />;
};
